'use client'

import { useLayoutEffect } from 'react'
import { defineCustomElements } from '@alice-health/wonderland/loader'

/**
 * Único ponto de registro dos custom elements do Wonderland no browser.
 *
 * O registro roda em `useLayoutEffect`, depois do commit da hidratação, e isso é
 * obrigatório. Os componentes do design system são `scoped`, então
 * `customElements.define` faz o Stencil escrever markup interno no light DOM de
 * forma síncrona, em todo `w-*` já presente no documento. Se isso acontecer
 * antes do commit, o React encontra DOM que não renderizou e falha com o erro
 * #418, que escala para o #423 e joga a raiz inteira para render de cliente.
 *
 * O `@alice-health/wonderland-react` também registrava as tags por conta
 * própria: o `createComponent` do `@stencil/react-output-target` chamava
 * `defineCustomElement()` na avaliação do módulo, e os wrappers são criados em
 * escopo de módulo — importar um `W*` registrava todas as tags. Esse `define`
 * eager é removido por `patches/@stencil+react-output-target+1.4.2.patch`
 * (HC-2628), o que deixa este componente como único registro.
 */
export const DesignSystemInit = () => {
  useLayoutEffect(() => {
    defineCustomElements(window)
  }, [])

  return null
}
